import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { productIdZodSchema } from "../product-id";
import type { ProductCommandCommon } from "./product-commands-common";

type ProductPauseCommand = ProductCommandCommon & {
    readonly _id: string;
    readonly _type: "PRODUCT_PAUSE_COMMAND";
};

type FactoryParams = Except<
    ProductPauseCommand,
    "_id" | "_type" | "_createdAt"
>;
const productPauseCommandFactory = (params: FactoryParams) => {
    const orderRejection: ProductPauseCommand = {
        ...params,
        _id: generateId({ prefix: "product_pause_command__" }),
        _type: "PRODUCT_PAUSE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return orderRejection;
};

const productPauseCommandZodSchema: z.ZodSchema<ProductPauseCommand> = z.object(
    {
        _id: idZodSchema,
        _type: z.literal("PRODUCT_PAUSE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        productId: productIdZodSchema,
    },
);

export { productPauseCommandFactory, productPauseCommandZodSchema };
export type { ProductPauseCommand };
